import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AgreeOn } from 'src/app/models/agree-on';
import { MemberStats } from 'src/app/models/member';
import { AuthService } from 'src/app/services/auth.service';
import { MainAppService } from 'src/app/services/main-app.service';
import { InfoDialogComponent } from '../../info-dialog/info-dialog.component';

@Component({
  selector: 'app-member-stats',
  templateUrl: './member-stats.component.html',
  styleUrls: ['./member-stats.component.css']
})
export class MemberStatsComponent implements OnInit {

  canSelectDates = false;
  public ageGroups:string = "";
  dateFrom = new Date( new Date().getFullYear(),  new Date().getMonth(), 1);
  dateUntil = new Date();

  memberStats: MemberStats
  dataSourceCountry: any;
  dataSourceMChannel: any;
  dataSourceAge: any;
  dataSourceProduct: any;
  dataSourcePaymentMethod: any;
  displayedColumnsPct: string[] = ['description', 'qty', 'pct'];
  displayedColumnsProduct: string[] = ['description', 'qty', 'startingPrice', 'finalPrice'];
  displayedColumnsPaymentMethod: string[] = ['description', 'qty', 'amount'];

  memberPaymentMethodsTotal:number = 0;
  memberProductsStartingPriceTotal:number = 0;
  memberProductsFinalPriceTotal:number = 0;

  memberPaymentMethodsQtyTotal:number = 0;
  memberProductsQtyTotal:number = 0;

  constructor(public dialog: MatDialog,public mainAppService: MainAppService, public auth: AuthService) {
    var _ageGroups = localStorage.getItem('_ageGroups');
    if(_ageGroups){
      this.ageGroups = _ageGroups;
    }
    else{
      this.ageGroups = "0,20,40";
    }
  }

  ngOnInit(): void {
    this.mainAppService.user().subscribe(user => {
      this.canSelectDates = user;
    })
  }

  search() {
    var valErrors = false;
    if (this.ageGroups){
      var ageGroupsArray = this.ageGroups.split(',');
      if (ageGroupsArray && ageGroupsArray.length>=2){
        ageGroupsArray.forEach(ageGroup => {
          if (!Number.isInteger(Number(ageGroup))){
            valErrors = true;
          }
        });
      }else {
        valErrors = true;
      }
    }else{
      valErrors = true;
    }

    if(!valErrors){
      localStorage.setItem('_ageGroups',this.ageGroups);
      this.mainAppService.getMemberStats(this.dateFrom, this.dateUntil, ageGroupsArray).subscribe(retval => 
        {
          if (retval && retval.responseData){
            this.memberStats = retval.responseData;
            this.dataSourceCountry = new MatTableDataSource(retval.responseData.memberCountries)
            this.dataSourceMChannel = new MatTableDataSource(retval.responseData.memberMarketingChannels)
            this.dataSourceAge = new MatTableDataSource(retval.responseData.memberAgeGroups)
            this.dataSourceProduct = new MatTableDataSource(retval.responseData.memberProducts)
            this.dataSourcePaymentMethod = new MatTableDataSource(retval.responseData.memberPaymentMethods)
            if (retval.responseData.memberPaymentMethods){
              this.memberPaymentMethodsTotal = retval.responseData.memberPaymentMethods.reduce((n, {amount}) => n + amount, 0)
              this.memberPaymentMethodsQtyTotal = retval.responseData.memberPaymentMethods.reduce((n, {qty}) => n + qty, 0)
            }
            if (retval.responseData.memberProducts){
              this.memberProductsStartingPriceTotal = retval.responseData.memberProducts.reduce((n, {startingPrice}) => n + startingPrice, 0)
              this.memberProductsFinalPriceTotal = retval.responseData.memberProducts.reduce((n, {finalPrice}) => n + finalPrice, 0)
              this.memberProductsQtyTotal = retval.responseData.memberProducts.reduce((n, {qty}) => n + qty, 0)
            }
          }
        });
    }else {
      var agreeDto = new AgreeOn();
      agreeDto.title = ""
      agreeDto.text = "Please specify age group as follows: 'To define age groups, use comma separated values (eg 0,20,40 for 0-19, 20-39, 40-..)'";
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: '400px',
        data: agreeDto
      });
    }
  }
}
